export default "__VITE_ASSET__DWNguypg__"